// window.Shopify.loadFeatures([{
// name: 'consent-tracking-api',   
// version: '0.1',
// }], function(error){
// if (!error) {
//   try {
//     window.Osano.cm.ready('shopify');

//     const triggers = document.querySelectorAll('[data-osano-trigger]');

//     const triggerOsano = (trigger, event) => {
//         Osano.cm.showDrawer('osano-cm-dom-info-dialog-open')
//     }

//     triggers.forEach(trigger => {
//         trigger.addEventListener('mousedown', () => triggerOsano());
//     });
//   } catch (error) {
//     console.error('Osano must be loaded before initializing the Shopify API.');
//   }
// }
// }); 

document.addEventListener('DOMContentLoaded', function() {

    const myInterval = setInterval(myTimer, 500);

    function myTimer() {
        if (Osano) {
            clearInterval(myInterval);
            const triggers = document.querySelectorAll('[data-osano-trigger]');

            const triggerOsano = (trigger, event) => {
                Osano.cm.showDrawer('osano-cm-dom-info-dialog-open')
            }

            triggers.forEach(trigger => {
                trigger.addEventListener('mousedown', () => triggerOsano());
            });
        }
    }
});